import React, {useState} from 'react';
import {useAuth0} from "@auth0/auth0-react";
import {Link, withRouter} from "react-router-dom";
import {Menu, Spin} from "antd";
import {
    HomeTwoTone,
    SafetyCertificateTwoTone,
    FileTextTwoTone,
    LoadingOutlined,
    BookTwoTone,
    SecurityScanTwoTone
} from "@ant-design/icons";
import LoginButton from "./LoginButton";
import ProfileContextMenu from "./ProfileContextMenu";
import {hasSufficientPermissions, isEngineeringAdmin, hasAccessToSupport} from "../../util/Permissions";
import {PRIMARY_COLOR} from "../../util/Colors";

/**
 * The top navigation menu bar.
 */
const Navbar = ({location, history}) => {
    const { isAuthenticated, isLoading, user } = useAuth0();

    const updateCurLoc = (pathname) => {
        let curKey = pathname;
        if (pathname === "/") {
            curKey = "home";
        }

        return curKey;
    }

    history.listen((location, action) => {
        if (action === "PUSH") {
            setCurrent(updateCurLoc(location.pathname));
        }
    });

    // make sure that highlighted nav item in menu bar matches URL user arrived on
    const [current, setCurrent] = useState(updateCurLoc(location.pathname));

    const onClick = e => {
        if (e.key === "login") {
            setCurrent("home");
            history.push("/");
        } else if (e.key !== "profile") {
            setCurrent(e.key);
        }
    };

    return (
        <Menu mode="horizontal" onClick={onClick} selectedKeys={current} >
            <Menu.Item key="home" icon={<HomeTwoTone twoToneColor={PRIMARY_COLOR}/>}>
                <Link to="/">Home</Link>
            </Menu.Item>
            {isAuthenticated && hasSufficientPermissions(user) && (<Menu.Item key="sign-extension" icon={<SafetyCertificateTwoTone twoToneColor={PRIMARY_COLOR}/>}>
                <Link to="/sign-extension">Sign Extension</Link>
            </Menu.Item>)}
            {isAuthenticated && hasSufficientPermissions(user) && (<Menu.Item key="generate-development-lic" icon={<FileTextTwoTone twoToneColor={PRIMARY_COLOR}/>}>
                <Link to="/generate-development-lic">Generate development.lic</Link>
            </Menu.Item>)}
            {isAuthenticated && hasAccessToSupport(user) && (<Menu.Item key="validate-license" icon={<SecurityScanTwoTone twoToneColor={PRIMARY_COLOR}/>}>
                <Link to="/validate-license">Inspect License Key</Link>
            </Menu.Item>)}
            {isAuthenticated && isEngineeringAdmin(user) && (<Menu.Item key="audit" icon={<BookTwoTone twoToneColor={PRIMARY_COLOR}/>}>
                <Link to="/audit-history">Audit History</Link>
            </Menu.Item>)}
            {!isAuthenticated && (<Menu.Item key="login" style={{float: 'right'}}>
                {isLoading ? <Spin indicator={<LoadingOutlined style={{ fontSize: 24 }} spin />} /> : <LoginButton />}
            </Menu.Item>)}
            {isAuthenticated && (<Menu.Item key="profile" style={{float: 'right'}}>
                <ProfileContextMenu/>
            </Menu.Item>)}

        </Menu>
    );
};

export default withRouter(Navbar);